import React, { useEffect, useState } from 'react';
import { Carousel, Container, Row } from 'react-bootstrap';
import img from './../../../assets/images/slider1.png';
import img2 from './../../../assets/images/slider2.png';
import lineorn from './../../../assets/lineornament.png';
import css from './Home.module.css';
import { Button } from 'react-bootstrap';
import { useBooks } from '../Books/BookState';
import BookCard from '../../../Components/Macro/BookCard/BookCard';
import { Link } from 'react-router-dom';
import { Modal, Space } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, FreeMode } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { useVideos } from '../../Admin/Videos/VideoStore';
import VideoCard from '../Videos/VideoCard';
import PostCard from '../Posts/PostCard';
import axios from 'axios';
import Stats from './Stats';

import gerb from './../../../assets/gerb.png';
import tatu from './../../../assets/tatu.png';
import samkutub from './../../../assets/samkutub.png';
import samdu from './../../../assets/samdu.png';
import atkrv from './../../../assets/atkrv.png';
import govuz from './../../../assets/govuz.png';
import ovgtm from './../../../assets/ovgtm.png';
import { PlayCircleFilled } from '@ant-design/icons';






function Home({ db }) {
    let [loader, setLoader] = useState(false)
    let [posts, setPosts] = useState([])
    let { booksLimit, getBooksLimit, getCats, getAuthors } = useBooks()
    let { videosLimit, setVideosLimit } = useVideos()
    let [videoModal, setVideoModal] = useState(false)

    useEffect(() => {
        getBooksLimit()
        getCats()
        getAuthors()
        setVideosLimit()
        axios.get('/postslimit').then(res => {
            if (res.status === 200) {
                setPosts(res.data)
            }
        })

    }, []);

    function savePdf(pdfUrl, pdfid, pdfname, pdfautor) {
        if (!pdfUrl) {
            return;
        }
        setLoader(true); // Loaderni ko'rsatish

        fetch(pdfUrl, {
            method: 'get',
            responseType: 'stream',
            headers: {
                "Content-type": "application/pdf"
            }
        }).then(res => {
            return res.blob()
        }).then(blob => {
            const transaction = db.transaction(['pdfs'], 'readwrite');
            const store = transaction.objectStore('pdfs');
            const pdfData = {
                id: String(pdfid),
                name: pdfname,
                author: pdfautor,
                blob: blob
                // blob: new Blob([blob.data], {type: 'application/pdf'})
                // blob: new Blob([blob.data], {type: 'text/plain'})
            };
            const request = store.put(pdfData);
            request.onsuccess = function () {
                setLoader(false); // Loaderni yashirish
            };

            request.onerror = function (event) {
                setLoader(false); // Loaderni yashirish
            };
        })
    }


    return (
        <>
            <Modal open={videoModal} onCancel={() => setVideoModal(false)} footer={null} width={'80%'} centered title="Kitobhon.uz - Video qo'llanma">
                <video controls style={{ width: '100%' }} src="https://api.familybook.uz/videoinfo.mp4" />
            </Modal>
            <div className={css.caruselContainer} style={{

            }}>
                <div className={css.mask}
                // style={{ backgroundImage: 'url(' + orn + ')' }}
                ></div>
                <Carousel className={css.carusel}>
                    <Carousel.Item className={css.slideritem} interval={5000}>
                        <img src={img} className={css.sliderimg} alt="IMG" />
                        <button className={css.ripplebtn} variant="primary" onClick={() => setVideoModal(true)}><PlayCircleFilled /></button>
                        <span className={css.rippletext}>Video Qo'llanma</span>
                        <div className={css.slidertext}>
                            <h1>Kitobhon.uz - Qiziqarli ma’lumotlar:</h1>
                            <p>“NOP World” xalqaro reyting agentligi ma’lumotlariga ko‘ra, dunyoda odamlar haftasiga 16,6 soat vaqtini televizor ko‘rishga sarflasa, 8,9 soatni kompyuter qarshisida o‘tkazadi, 6,5 soatni esa mutolaaga ajratadi. 2016 yilda haftasiga eng ko‘p kitob o‘qiydigan mamlakatlar ro‘yxatida Hindiston - 10,7, Tailand - 9,4, Xitoy - 8, Filippin - 7,6, Chexiya - 7,4, Rossiya - 7,1, Shvesiya - 6,9, Fransiya - 6,9 va Vengriya - 6,8 soat bilan yuqori o‘rinlarni egalladi;
                            </p>
                            <Stats />
                            <Space>
                                <Link to={'/about'}><Button variant="primary">Biz haqqimizda</Button></Link>
                                <Link to={'/books'}><Button variant="success">Kitoblar</Button></Link>
                            </Space>
                        </div>


                    </Carousel.Item>
                    <Carousel.Item className={css.slideritem} interval={5000}>
                        <img src={img2} className={css.sliderimg} alt="IMG" />
                        <button className={css.ripplebtn} variant="primary" onClick={() => setVideoModal(true)}><PlayCircleFilled /></button>
                        <span className={css.rippletext}>Video Qo'llanma</span>
                        <div className={css.slidertext}>
                            <h1>Kitobhon.uz - Qulaylik va Ergonomika</h1>
                            <p> Onlayn kitob o’qishni tashkil etish uchun mo’ljallangan platforma o’quvchilarga smartfon, planshet yoki kompyuter orqali o’qish imkonini beradi. Bu esa Kitobxon vaqtini tejash, bitta kitobdan bir vaqtning o’zida millionlab o’quvchilar foydalana olish imkoniyatini beradi. Kitob sotib olish imkoni bo’lmagan holda o’quvchi mablag’lari tejalishi imkonini ham beradi;</p>

                            <Stats />
                            <Space>
                                <Link to={'/about'}><Button variant="primary">Biz haqqimizda</Button></Link>
                                <Link to={'/forum'}><Button variant="success">Forum</Button></Link>
                            </Space>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item className={css.slideritem} interval={5000}>
                        <img src={img2} className={css.sliderimg} alt="IMG" />
                        <button variant="primary" onClick={() => setVideoModal(true)} className={css.ripplebtn}><PlayCircleFilled /></button>
                        <span className={css.rippletext}>Video Qo'llanma</span>
                        <div className={css.slidertext}>
                            <h1>Kitobhon.uz - Qulay qidiruv
                            </h1>
                            <p>Har bir foydalanuvchi Platformada o’ziga kеrakli bo’lgan mavjud kitoblarni mavzusi, muallifi, tarkibidagi so’z yoki jumla bo’yicha hamda ma'lumotlarni uning tili bo’yicha qidirib topishi mumkin. Shuningdek foydalanuvchi o’quvchi o’ziga yoqqan sahifalar yoki paragraflarni belgilab qo’yishlari mumkin;</p>

                            <Stats />
                            <Space>
                                <Link to={'/about'}><Button variant="primary">Biz haqqimizda</Button></Link>
                                <Link to={'/forum'}><Button variant="success">Forum</Button></Link>
                            </Space>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item className={css.slideritem} interval={5000}>
                        <img src={img2} className={css.sliderimg} alt="IMG" />
                        <button className={css.ripplebtn} variant="primary" onClick={() => setVideoModal(true)}><PlayCircleFilled /></button>
                        <span className={css.rippletext}>Video Qo'llanma</span>
                        <div className={css.slidertext}>
                            <h1>Kitobhon.uz -Keng tanlov
                            </h1>
                            <p>Plarformada xilma-xil janrlar, adabiy-badiiy, ilmiy, klassik adabiyotlar, fantastik, romantic, tarixiy, falsafiy va estetik yo‘nalishlarda, ilmiy-ommabop kitoblar, o‘tmish ajdodlarimizning kitoblari, pandnomalari, ilg‘or xorij adabiyoti vakillarining eng sara asarlari kirill va joriy lotin alifbosida, bundan tashqari video darslar, audio kitoblar, qiiziqarli test savollari, O’zbek va chet tillardagi musiqalar kitobxon talabi uchun taqdim etildi;</p>
                            <Stats />

                            <Space>
                                <Link to={'/about'}><Button variant="primary">Biz haqqimizda</Button></Link>
                                <Link to={'/forum'}><Button variant="success">Forum</Button></Link>

                            </Space>
                        </div>
                    </Carousel.Item>
                </Carousel>
            </div>



            <Container style={{ backdropFilter: 'blur(10px)', padding: '25px' }}>
                <div className="section-header">
                    <h2>Oxirgi qo'shilgan kitoblar</h2>
                    <Link to={'/books'}><Button variant="outline-primary" size="sm">Barchasini ko'rish →</Button></Link>
                </div>
                <Swiper
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2, // Mobil uchun
                        },
                        1024: {
                            slidesPerView: 4, // Kompyuter uchun
                        },
                    }}
                    loop={true}
                    spaceBetween={30}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                        el: '.swiper-pagination'
                    }}
                    modules={[FreeMode, Pagination]}
                    className="mySwiper"
                >
                    {booksLimit.map(book => (
                        <SwiperSlide key={book.id}>
                            <BookCard key={book.id} book={book} saveBook={savePdf} />
                        </SwiperSlide>
                    ))}

                </Swiper>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '25px 0' }}>
                    <img src={lineorn} alt="lineornament" height={100} />
                </div>
            </Container>
            <Container style={{ backdropFilter: 'blur(10px)', padding: '25px' }}>
                <div className="section-header">
                    <h2>Oxirgi qo'shilgan videolar</h2>
                    <Link to={'/videos'}><Button variant="outline-primary" size="sm">Barchasini ko'rish →</Button></Link>
                </div>
                <Swiper
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2, // Mobil uchun
                        },
                        1024: {
                            slidesPerView: 4, // Kompyuter uchun
                        },
                    }}
                    loop={true}
                    spaceBetween={30}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[FreeMode, Pagination]}
                    className="mySwiper"
                >
                    {videosLimit.map(v => (
                        <SwiperSlide key={v.id}>
                            <VideoCard key={v.id} post={v} />
                        </SwiperSlide>
                    ))}

                </Swiper>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '25px 0' }}>
                    <img src={lineorn} alt="lineornament" height={100} />
                </div>

            </Container>
            <Container style={{ backdropFilter: 'blur(10px)', padding: '25px' }}>
                <div className="section-header">
                    <h2>Oxirgi qo'shilgan maqolalar</h2>
                    <Link to={'/posts'}><Button variant="outline-primary" size="sm">Barchasini ko'rish →</Button></Link>
                </div>
                <Swiper
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2, // Mobil uchun
                        },
                        1024: {
                            slidesPerView: 4, // Kompyuter uchun
                        },
                    }}
                    loop={true}
                    spaceBetween={30}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' + (index + 1) + '</span>';
                        },
                    }}
                    modules={[FreeMode, Pagination]}

                    className="mySwiper"
                >
                    {posts.map(book => (
                        <SwiperSlide key={book.id}>
                            <PostCard post={book} />
                        </SwiperSlide>
                    ))}

                </Swiper>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '25px 0' }}>
                    <img src={lineorn} alt="lineornament" height={100} />
                </div>
            </Container>

            <Container style={{ backdropFilter: 'blur(10px)', padding: '25px' }}>
                <div className="section-header" style={{ justifyContent: 'center' }}>
                    <h2>Hamkorlarimiz</h2>
                </div>

                <Row>
                    <Swiper
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            640: {
                                slidesPerView: 2, // Mobil uchun
                            },
                            1024: {
                                slidesPerView: 3, // Kompyuter uchun
                            },
                        }}
                        loop={true}
                        spaceBetween={30}
                        freeMode={true}
                        pagination={{
                            clickable: true,
                            renderBullet: function (index, className) {
                                return '<span class="' + className + '">' + (index + 1) + '</span>';
                            },
                        }}
                        modules={[FreeMode, Pagination]}

                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <div className={css.partnercard}>
                                <img src={ovgtm} alt="ovgtm" width={50} height={50} />
                                <h6 style={{ textAlign: 'center' }}>OILA VA GENDER <br /> ILMIY TADQIQOT INSTITUTI</h6>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={css.partnercard}>
                                <img src={govuz} alt="" />
                                <h6 style={{ textAlign: 'center' }}>GOVUZ <br /> Hukumat portali</h6>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={css.partnercard}>
                                <img src={samdu} alt="" />
                                <h6 style={{ textAlign: 'center' }}>Samarqand davlat universiteti</h6>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={css.partnercard}>
                                <img src={tatu} alt="" />
                                <h6 style={{ textAlign: 'center' }}>Toshkent axborot texnologiyalari universiteti <br /> Samarqand filiali</h6>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={css.partnercard}>
                                <img src={samkutub} alt="" />
                                <h6 style={{ textAlign: 'center' }}>A.S. Pushkin nomidagi <br /> Samarqand davlat kutubxonasi</h6>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={css.partnercard}>
                                <img src={gerb} alt="" />
                                <h6 style={{ textAlign: 'center' }}>Samarqand viloyati maxsuz ko'zi ojizlar kutubxonasi</h6>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </Row>
            </Container>

            <Container style={{ backdropFilter: 'blur(10px)', padding: '25px', marginBottom: '15px' }}>
                <div className="section-header">
                    <h2>Foydali havolalar</h2>
                </div>
                <Swiper
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2, // Mobil uchun
                        },
                        1024: {
                            slidesPerView: 4, // Kompyuter uchun
                        },
                    }}
                    loop={true}
                    spaceBetween={30}
                    freeMode={true}
                    pagination={{
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' + (index + 1) + '</span>';
                        },
                    }}
                    modules={[FreeMode, Pagination]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <a href="https://play.google.com/store/apps/details?id=uz.ibrat.farzandlari" target="_blank" rel="noopener noreferrer">
                            <div className={css.partnercard}>
                                <h6 style={{ textAlign: 'center' }}>Ibrat farzandlari</h6>
                                <p style={{ textAlign: 'center' }}>loyihasi doirasida 20 dan ortiq xorijiy til o’rganuvchilar uchun maxsus mobil ilova "Ibrat Academy" mobil loyihasini taqdim etadi</p>
                            </div>
                        </a>
                    </SwiperSlide>
                    <SwiperSlide>
                        <a href="https://play.google.com/store/apps/details?id=uz.mutolaa.commercial.mutolaa" target="_blank" rel="noopener noreferrer">
                            <div className={css.partnercard}>
                                <h6 style={{ textAlign: 'center' }}>Mutolaa</h6>
                                <p style={{ textAlign: 'center' }}>Kitobxon yoshlarimiz uchun yana bir yangi mega loyiha "Mutolaa" mobil loyihasini taqdim etadi.</p>
                            </div>
                        </a>
                    </SwiperSlide>
                    <SwiperSlide>
                        <a href="https://onelink.to/bce72z" target="_blank" rel="noopener noreferrer">
                            <div className={css.partnercard}>
                                <h6 style={{ textAlign: 'center' }}>Ustoz AI</h6>
                                <p style={{ textAlign: 'center' }}>Zamonaviy kasblar va fanlarni toʻliq bepulga oʻrgatuvchi "Ustoz AI" mobil ilovasini taqdim etadi.</p>
                            </div>
                        </a>
                    </SwiperSlide>
                    <SwiperSlide>
                        <a href="https://play.google.com/store/apps/details?id=uz.uzchess.akademiya&pli=1" target="_blank" rel="noopener noreferrer">
                            <div className={css.partnercard}>
                                <h6 style={{ textAlign: 'center' }}>UzChess</h6>
                                <p style={{ textAlign: 'center' }}>O'zbek tilida shaxmatni tez, oson va bepul o'rgatuvchi yagona "UzChess" mobil ilovasini taqdim etadi.</p>
                            </div>
                        </a>
                    </SwiperSlide>
                    <SwiperSlide>
                        <a href="https://play.google.com/store/apps/details?id=uz.globalmove.girls_academy&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                            <div className={css.partnercard}>
                                <h6 style={{ textAlign: 'center' }}>Qizlar akademiyasi</h6>
                                <p style={{ textAlign: 'center' }}>Xotin-qizlar uchun zamonaviy kasblar bepul o'rgatuvchi ta’lim platformasi "Qizlar akademiyasi" mobil ilovasini taqdim etadi.</p>
                            </div>
                        </a>
                    </SwiperSlide>
                </Swiper>

            </Container>
        </>
    );
}

export default Home;
